import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Clock, XCircle } from "lucide-react";

export default function BookingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling"); // polling | paid | expired | error
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      if (attempts >= 6) { setStatus("timeout"); return; }
      try {
        const r = await api.get(`/checkout/status/${sessionId}`);
        setData(r.data);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        attempts++;
        setTimeout(poll, 2000);
      } catch {
        attempts++;
        setTimeout(poll, 2000);
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div data-testid="success-page">
      <Navbar/>
      <div className="pt-40 pb-20 px-6 max-w-2xl mx-auto text-center">
        {status === "polling" && (<>
          <Clock size={56} className="text-[#5DCFE5] mx-auto mb-6 animate-pulse"/>
          <h1 className="font-serif text-4xl mb-2">Processing payment...</h1>
          <p className="text-[#6b7c8a]">Hold tight — we're confirming your reservation.</p>
        </>)}
        {status === "paid" && (<>
          <CheckCircle2 size={72} className="text-[#5DCFE5] mx-auto mb-6"/>
          <p className="eyebrow mb-3">Confirmed</p>
          <h1 className="font-serif text-5xl mb-4">Your ride is <span className="italic gradient-gold">booked.</span></h1>
          <p className="text-[#b8c5d1] mb-2">Total paid: <span className="text-[#5DCFE5] font-bold">${(data?.amount_total/100).toFixed(2)}</span></p>
          <p className="text-[#6b7c8a] mb-10">A confirmation will be sent to your email shortly. Welcome aboard.</p>
          <Link to="/" data-testid="back-home" className="btn-gold">Back to Home</Link>
        </>)}
        {(status === "expired" || status === "error" || status === "timeout") && (<>
          <XCircle size={56} className="text-red-400 mx-auto mb-6"/>
          <h1 className="font-serif text-4xl mb-2">Something went wrong</h1>
          <p className="text-[#6b7c8a] mb-8">Payment could not be confirmed. Please try again or contact us.</p>
          <Link to="/book" className="btn-gold">Try Again</Link>
        </>)}
      </div>
      <Footer/>
    </div>
  );
}
